import { DOCUMENT } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { installTruncatedTextTitles } from './shared/utils/truncated-title.util';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet],
})
export class AppComponent {
    /**
     * Constructor
     */
    constructor() {
        // #420: hovering any cut-off grid/ellipsis text shows the full text, app-wide
        installTruncatedTextTitles(inject(DOCUMENT));
    }
}
